const FronSY = [
  {
    title: "#供应商信息",
    operationFlag: false,
    FromArr: [
      {
        title: "所属大区经理",
        modelvalue: "",
        inputtype: "input",
        inputflag: true,
        fontSize: 14,
        color: "#424E66",
        lableheight: 20,
        btx: false,
        types: "text",
        placeholder: "请输入内容",
        width: 270,
        height: 32,
        disabled: false,
      },
      {
        title: "所属大区经理",
        inputtype: "input",
        inputflag: true,
        fontSize: 14,
        color: "#424E66",
        lableheight: 20,
        btx: false,
        types: "text",
        placeholder: "请输入内容",
        width: 270,
        height: 32,
        disabled: false,
      },
      {
        title: "负责销售人员",
        inputtype: "input",
        inputflag: true,
        fontSize: 14,
        color: "#424E66",
        lableheight: 20,
        btx: false,
        types: "text",
        placeholder: "请输入内容",
        width: 270,
        height: 32,
        disabled: false,
      },
      {
        title: "负责销售人员",
        inputtype: "input",
        inputflag: true,
        fontSize: 14,
        color: "#424E66",
        lableheight: 20,
        btx: false,
        types: "text",
        placeholder: "请输入内容",
        width: 270,
        height: 32,
        disabled: false,
      },
    ],
  },
];

export default FronSY;
